import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  private localStorageService;
  constructor() {
    this.localStorageService = localStorage;
  }
  addItem(object: any, key: string): void {
    this.localStorageService.setItem(key, JSON.stringify(object));
  }

  getItemArray(key: string): any[] {
    var data = this.localStorageService.getItem(key);
    return data ? <any[]>JSON.parse(data) : [];
  }

  getItem(key: string): any {
    var data = this.localStorageService.getItem(key);
    return data ? <any>JSON.parse(data) : null;
  }

  getItem2(key: string): any {
    return this.localStorageService.getItem(key);
  }


  removeItem(key): void {
    this.localStorageService.removeItem(key);
  }
}
